export const DO_URI = 'nyc3.digitaloceanspaces.com';
export const DO_ORIGIN_URL = `https://${
  import.meta.env.VITE_DO_BUCKET_NAME
}.nyc3.digitaloceanspaces.com`;
export const DO_CDN_URL = `https://${
  import.meta.env.VITE_DO_BUCKET_NAME
}.nyc3.cdn.digitaloceanspaces.com`;
export const SUPPORT_EMAIL = 'support@litefarm.org';

// Changing this forces logout and updates the new release card
export const APP_VERSION = '3.7.0';
export const VERSION_RELEASE_NOTES_LINK =
  'https://www.litefarm.org/post/start-2025-right-manage-crops-and-animals-seamlessly-with-litefarm';

export const CONSENT_VERSION = '7.1';

export const BETA_BADGE_LINK =
  'https://www.litefarm.org/post/beta-features-on-litefarm-your-feedback-matters';
